<template>
  <div class="p_list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>商品列表
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="clear menu11">
        <button
          class="btn3 clear-item"
          @click="setType(0)"
          v-bind:class="{ active: resType == 0 }"
        >全部商品 {{count0}}</button>
        <button
          class="btn3 clear-item"
          @click="setType(1)"
          v-bind:class="{ active: resType == 1 }"
        >已上架 {{count1}}</button>
        <button
          class="btn3 clear-item"
          @click="setType(2)"
          v-bind:class="{ active: resType == 2 }"
        >未上架 {{count2}}</button>
        <button
          class="btn3 clear-item"
          @click="setType(3)"
          v-bind:class="{ active: resType == 3 }"
        >有货 {{count3}}</button>
        <button
          class="btn3 clear-item"
          @click="setType(4)"
          v-bind:class="{ active: resType == 4 }"
        >无货 {{count4}}</button>
      </div>
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;margin-bottom: 20px;">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">输入搜索</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="name" placeholder="请输入商品名称" size="small"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">商品分类</div>
          </el-col>
          <el-col :span="4">
            <el-select v-model="category" placeholder="请选择" size="small">
              <el-option v-for="i in categorys" :key="i.id" :label="i.cate_name" :value="i.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <div class="label">品牌分类</div>
          </el-col>
          <el-col :span="4">
            <el-select v-model="brand" placeholder="请选择" size="small">
              <el-option v-for="item in brands" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6" align="center">
            <button class="btn11" @click="loadData()">搜索</button>
            <button class="btn22" @click="clear()">清空</button>
          </el-col>
        </el-row>
      </div>

      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">数据列表</div>
        <div v-if="detailsNum != ''" style="float: right;line-height: 46px;padding-right: 10px;">
          <div class="center_list_head_rig"><router-link to="/admin/add1">添加商品</router-link> </div>
          详情数量 (
          <span style="color: #e2211c">{{detailsNum}}</span> )
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" label="编号" prop="id" width="70"></el-table-column>
          <el-table-column align="center" label="商品图片">
            <template slot-scope="scope">
              <img
                v-if="scope.row.images[0] =='null' || scope.row.images[0] ==''"
                style="width: 70px;height: 70px;"
                :src="serve+'/upload/img1_6250.jpg'"
                alt
              />
              <img v-else style="width: 70px;height: 70px;" :src="serve+scope.row.images[0]" />
              <!-- {{scope.row.images[0]}} -->
            </template>
          </el-table-column>
          <el-table-column align="center" label="商品名称" prop="title" show-overflow-tooltip></el-table-column>
          <el-table-column align="center" label="价格" prop="selling_price" width="100"></el-table-column>
          <el-table-column align="center" prop="item_no" label="货号"></el-table-column>
          <el-table-column align="center" prop="sales" label="销量" width="80"></el-table-column>
          <el-table-column align="center" label="上/下架" width="90">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.selling"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                active-value="1"
                inactive-value="0"
                @change="setSelling($event,scope.row.id)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="top_class" label="分类"></el-table-column>
          <el-table-column align="center" prop="address" label="操作" width="120">
            <template slot-scope="scope" align="center">
              <button class="button1" @click="edit(scope.row.id)">编辑</button>
              <button class="button1" @click="del(scope.row.id)">删除</button>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="address" label="精选" width="60">
            <template slot-scope="scope" align="center">
              <button
                class="button1"
                @click="changeShare(scope.row.id)"
              >{{scope.row.choiceness == 0 ? '普通' : '精选' }}</button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pager">
          <el-row>
            <el-col :span="2" style="padding-left:10px;line-height: 34px">
              <el-checkbox v-model="selectAll" @change="selectAllFn">全选</el-checkbox>
            </el-col>
            <el-col :span="8">
              <button @click="delArr()" class="btn1">批量删除</button>
            </el-col>
            <el-col :span="12">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="20"
                :current-page="currrent_page"
                @current-change="setPage"
              ></el-pagination>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      //
      role:true,
      count0: 0, //全部商品数量
      count1: 0, //已上架 数量
      count2: 0, //未上架 数量
      count3: 0, //有货 数量
      count4: 0, //无货 数量
      name: null,
      category: null,
      categorys: [],
      brand: null,
      brands: [],
      tableData: [],
      multipleSelection: [],
      total: 0,
      currrent_page: 1,
      selectAll: false,
      checked: [],
      idString: "",
      resType: 0,
      username: "",
      token: "",
      detailsNum: ""
    };
  },
  mounted() {
    //
  },
  created() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "商品列表";
    if (this.$route.query.page) {
      this.currrent_page = this.$route.query.page;
    }
    this.loadData();
    this.get_brand_name();
    this.get_cate_name();
    this.details();
    // window.history.forward("1232131")
  },
  methods: {
    details() {
      this.axios
        .get(this.serve + "/admin/productInfoNumber", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "error") {
            this.detailsNum = ''
          } else {
            this.detailsNum = res.data;
          }
        });
    },
    changeShare(id) {
      this.axios
        .get(this.serve + "/admin/choiceness", {
          params: {
            token: this.token,
            username: this.username,
            id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.loadData();
            this.$message({
              type: "success",
              message: "操作成功",
              offset: 200
            });
          }
        });
    },
    //
    clear() {
      this.name = null;
      this.brand = null;
      this.category = null;
      this.loadData();
    },
    setType(type) {
      this.resType = type;
      this.loadData();
    },
    get_cate_name() {
      var that = this;
      this.axios
        .get(this.serve + "/admin/get_cate_name", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            that.categorys = res.data.data;
          }
        });
    },
    get_brand_name() {
      var that = this;
      this.axios
        .get(this.serve + "/admin/get_brand_name", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            that.brands = res.data.data;
          }
        });
    },
    selectAllFn(v) {
      this.$refs.multipleTable.toggleAllSelection();
    },
    edit(id) {
      // alert(id);

      this.$router.push({
        path: "./comd_compile/" + id + "?page=" + this.currrent_page
      });
    },
    delArr() {
      this.del(this.idString);
    },
    del(id) {
      this.$confirm("此操作将永久删除该商品, 是否继续?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/del_product", {
              params: {
                username: this.username,
                token: this.token,
                id: id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$notify({
                  title: "商品已删除",
                  type: "success"
                });
                this.loadData();
              }else{
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    loadData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      var params = {
        username: this.username,
        token: this.token,
        page: this.currrent_page,
        title: this.name,
        top_class: this.category,
        brand: this.brand,
        resType: this.resType
      };

      this.axios
        .get(this.serve + "/admin/get_product", {
          params: params
        })
        .then(res => {
          if (res.data.status == "success") {
            this.total = res.data.data.total;
            this.count0 = res.data.data.count0;
            this.count1 = res.data.data.count1;
            this.count2 = res.data.data.count2;
            this.count3 = res.data.data.count3;
            this.count4 = res.data.data.count4;
            delete res.data.data.total;
            delete res.data.data.currrent_page;
            delete res.data.data.count0;
            delete res.data.data.count1;
            delete res.data.data.count2;
            delete res.data.data.count3;
            delete res.data.data.count4;
            this.tableData = [];
            for (var key in res.data.data) {
              if (res.data.data[key].images != null) {
                res.data.data[key].images = res.data.data[key].images.split(
                  ";"
                );
              } else {
                res.data.data[key].images = [
                  "http://iph.href.lu/70x70?text=\u6682\u65e0\u56fe\u7247&bg=CCCCFF"
                ];
              }
              this.tableData.push(res.data.data[key]);
            }
          } else {
            if(res.data.code == '403')
            {
              this.role = false
            }
            this.tableData = [];
          }
          loading.close();
        });
    },
    handleSelectionChange(v) {
      this.idString = "";
      var tmpString = "";
      for (var item of v) {
        if (tmpString == "") {
          tmpString = item.id;
        } else {
          tmpString = tmpString + "," + item.id;
        }
      }
      this.idString = tmpString;
    },
    setPage(v) {
      //
      console.log(v);
      this.currrent_page = v;
      this.loadData();
      this.selectAll = false;
    },
    setSelling(v, id) {
      this.axios
        .get(this.serve + "/admin/update_product_selling", {
          params: {
            username: this.username,
            token: this.token,
            id: id,
            selling: v
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            if (v == 0) {
              var str = "下架";
            } else {
              var str = "上架";
            }
            this.$notify({
              title: "商品已" + str,
              type: "success"
            });
          }
        });
    }
  }
};
</script>
<style lang="scss">
.button1 {
  // border: 0;
  border: none;
  outline: none;
  background: none;
  font-size: 14px;
  font-family: "MicrosoftYaHeiLight";
  font-weight: 300;
  line-height: 18px;
  cursor: pointer;
}
.button1:hover {
  color: #0099ff;
}
.btn11 {
  margin-right: 20px;
  width: 74px;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
}
.btn11:hover {
  color: #0099ff;
}
.btn22 {
  margin-right: 20px;
  width: 74px;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
}
.btn22:hover {
  color: #0099ff;
}
.p_list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .menu11 {
    margin-bottom: 20px;
    .clear-item {
      margin-right: 25px;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
.center_list_head_rig {
  width: 100px;
  height: 30px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  font-size: 12px;
  font-family: "MicrosoftYaHeiLight";
  font-weight: 300;
  color: rgba(153, 153, 153, 1);
  margin: 7px 30px 0 0;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.center_list_head_rig a{color:rgba(153,153,153,1)}
.center_list_head_rig a:hover {
  color: #0099ff;
}
</style>